/* import __COLOCATED_TEMPLATE__ from './chart-line.hbs.js'; */
import Component from '@glimmer/component';
export default class ChartLine extends Component {
  get fill() {
    return this.args.fill || 'var(--core-text-10-light-mode-color)';
  }
}